import { BrowserRouter, Switch, Route } from "react-router-dom";
import styles from "./styles/app.scss";
import Routes from "./routes/User/routes.js";
import AdminRoutes from "./routes/Admin/AdminRouter.js";
import NotFound from "./pages/NotFound/NotFound";
import GlobalNotifications from "./components/Notifications/GlobalNotifications";

function App() {
  return (
    <div className={styles.app}>
      <BrowserRouter>
        <GlobalNotifications />
        <Switch>
          {/* Admin routes - all admin routes should start with /admin */}
          <Route path="/admin" component={AdminRoutes} />

          {/* User routes - handles all user and public pages */}
          <Route path="/" component={Routes} />

          {/* 404 - Global catch-all (should be last) */}
          <Route path="*" component={NotFound} />
        </Switch>
      </BrowserRouter>
    </div>
  );
}

export default App;